export const initialState = () => ({
  catalog: {
    academicYears: [],
    months: [],
    specialists: [],
    status: [],
    centers: [],
    providers: [],
    services: [],
  },
  filter: {
    academicYear: null,
    month: null,
    specialist: null,
    center: null,
    status: null,
    referral: null,
    sie: null,
    hasResults: false,
    results: [],
    specialistInfo: {},
    provider: null,
    service: null,
  },
  paging: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
  },
  configPaginated: {
    pageSize: 15,
  },
});

export const state = initialState();
